import { VERTICAL_ASPECT_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const tiktokPage: TemplatePage = {
  header: {
    color: '#73F0ED',
    icon: 'images/video-templates/tiktok.webp',
    title: 'TikTok Video Templates',
    title_meta: '500+ Editable and Free TikTok Video Templates',
    description_meta:
      'Create viral-worthy TikTok videos with Wave.video’s collection of 400+ easy-to-edit and free templates. Try now!',
    description:
      'Create viral-worthy TikTok videos that attract attention with our collection of easy-to-edit and free templates.' +
      ' Put your content in the spotlight and gain more followers with minimal effort!'
  },
  footer: {
    category: 'TikTok',
    description:
      'With Wave.video’s customizable and free TikTok video templates, you can make unique and professional-looking videos' +
      ' with no advanced editing skills. Browse our eye-catching templates for designs you can effortlessly personalize and' +
      ' share with your audience. Creating trendy videos for TikTok has never been easier!'
  },
  content: [
    {
      type: 'templates',
      title: 'TikTok video templates',
      search: {
        aspects: VERTICAL_ASPECT_STRING
      }
    },
    { type: 'stocks', title: 'tiktok', search: { name: 'tiktok' } },
    { type: 'calendar' }
  ]
};

export default tiktokPage;
